var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcUpYellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1842",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.041,
    height: 22.041,
    viewBox: "0 0 22.041 22.041",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "9kr9p964ea",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAAe5JREFUOI2tlU+S0kAUxn+vQavchaUroLwAN5AbGFdu5wZmTmLceQuZE0y4AZ6A4ModwYUD6aSfi/yhCWEKB1OVSn1dr7/+8stLt3Dh0m0YsHcf0EMIxQQ9zKAAzVPUrnB5gjs8yDRN++bLueFdQP7nM1pEqA3QHNQCFjSvn82dZ1DEuN9fZZplF40r0+IR7AyXUyeszLpaa12Nr9CnjzLN0jNj3d4FWFlXKb2ETbr+xL7OoJw2yU1lGgXY148gAVovp966QjUgUo/36gDK740yABRFhMisNVHPrH0IqHrv2NEiAHNdv4kARLdRQFmucYfgWaYuB2mYdhhLp172I0NpQlSDNkGTUFoeR30pcbe+HMwNqmHbFg2zlzBWPdYbQtOy9YLg1fwb4+YN9b1BdezN9sz79JWJRSam/ppcxZhnEnNab0A3x2Q3MPb5CRsDrPA8buvjdpXEoJKcYGjNTxLUJhcSd+sdiWHoFqC7/9rHg3JhZBSnQHwz47Zr9F6mZNVeMRzGwI9zxkePKxkv5d0hhnoTklGcUUoI7E4Z9zC/nHgHg/YvNu3ct99SXrkJIssX9PES3MQ/Rc6OJgD99SlC7ZfTzd0/MTyt9l7GP+OuR68xUB2mT+UcbIjmc7DjepENziZgE8r9QqZp1jf/L7fVfTZ/QwnPAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 79",
    d: "M11.021 0a10.986 10.986 0 1 1-4.29.866A10.986 10.986 0 0 1 11.021 0z",
    style: {
      fill: "url(#9kr9p964ea)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3269",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.812 6.659 7.165 1.5l-5.04 5.159",
    style: {
      stroke: "none"
    },
    transform: "translate(4.3 6.666)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.165 0h.03a1.508 1.508 0 0 1 1.086.497l4.647 5.156a1.5 1.5 0 0 1-.11 2.122 1.508 1.508 0 0 1-1.311.356 1.502 1.502 0 0 1-.811-.466L7.12 3.698 3.2 7.71a1.52 1.52 0 0 1-.502.339 1.501 1.501 0 0 1-1.623-.315 1.499 1.499 0 0 1-.025-2.125L6.09.453A1.503 1.503 0 0 1 7.165 0z",
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    transform: "translate(4.3 6.666)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcUpYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-upYellow.2f050fe1fcf974f37b29a6fbbf8b7320.svg";